<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="资讯标题:">
          <el-input v-model="listQuery['filter[name]']" clearable placeholder="资讯标题"></el-input>
        </el-form-item>
        <el-form-item label="选择考试:">
          <el-select v-model="listQuery['filter[exam_id]']"  clearable placeholder="请选择">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="id" label="序号">
      </el-table-column>
      <el-table-column prop="name" label="资讯标题" >
      </el-table-column>
      <el-table-column prop="created_at" label="发布时间" >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small"  @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑资讯':'新增资讯'">
      <el-form :model="notice" label-width="80px" label-position="left">
        <el-form-item label="选择考试:">
          <el-select  v-if="dialogType==='edit'" disabled v-model="notice.exam_id"  clearable placeholder="请选择" >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select  v-else v-model="notice.exam_id"  clearable placeholder="请选择" >
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" >
          <el-input  v-if="dialogType==='edit'" disabled v-model="notice.name" placeholder="标题"/>
          <el-input  v-else v-model="notice.name" placeholder="标题"/>
        </el-form-item>
        <el-form-item label="内容" >
          <el-input type="textarea" v-model="notice.content" placeholder="内容"/>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        notice:{},
        examList:[],
        total:0,
        dialogType:'new',
        dialogVisible:false,
        listQuery: {
            page: 1,
            per_page:20
        },
      tableData: []
    };
  },
  computed: {

  },
  created() {
    this.getData();
    this.getExamList()
  },
  methods: {
      getExamList()
      {
        this.$http.examsList({page_size:100000}).then(res=>{
            this.examList=res.data;
        })
      },
    search() {
      this.listQuery.page = 1;
      this.getData()
    },
    // 获取全部的课程列表
    getData() {
      this.$http.getNotices( this.listQuery)
        .then(res => {
          this.tableData = res.data;
            this.total = res.meta.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
      handleAdd() {
          this.notice = {};
          this.dialogType = 'new';
          this.dialogVisible = true
      },
      handleEdit(scope) {
          this.dialogType = 'edit';
          this.dialogVisible = true;
          this.$http.getNotice(scope.row.id,{include:'subjects'}).then(res=>{
              this.notice =res.data
          })
      },
      confirmSave(){
          const isEdit = this.dialogType === 'edit'
          if (isEdit) {
              this.$http.updateNotice(this.notice.id, this.notice).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  });
                  this.getData()
              })
          } else {
              this.$http.addNotice(this.notice).then(res => {
                  this.dialogVisible = false
                  this.$notify({
                      title: 'Success',
                      message: '操作成功！',
                      type: 'success'
                  })
                  this.getData()
              })
          }
      },
      handleDelete({$index, row}) {
          this.$confirm('确定要删除此条吗?', '警告', {
              confirmButtonText: '删除',
              cancelButtonText: '取消',
              type: 'warning'
          })
              .then(() => {
                  this.$http.deleteNotice(row.id).then(res => {
                      this.tableData.splice($index, 1)
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                  });

              })
              .catch(err => {
                  console.error(err)
              })
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/examManage/notice.vue